import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Panel, Icon} from '../';

function HelpPanel({isOpened, onClose}) {
  const classes = classnames(
    'help-panel',
    {
      'help-panel_displayed': isOpened,
    }
  );
  const closeButton = () => (
    <span className="help-panel__close" tabIndex={0} role="button" onClick={onClose}>
      <Icon glyph="close" iconSize="28"/>
    </span>
  );

  return (
    <div className={classes}>
      <Panel title="Help" renderActions={closeButton()}>
        <div className="help-panel__content">
          <h3>Troubleshooting connection issues</h3>
          <p><span className="help__hilight">If you are having problems with poor quality or freezing, here are a few recommendations that may help:</span></p>
          <ol>
            <li className="help__hilight"><span>Make sure that you are using the latest version of your browser. </span></li>
            <li className="help__hilight"><span>Check your connection. </span></li>
            <ul>
              <li className="help__hilight"><span>On a computer: </span></li>
              <ol type="a">
                <li className="help__hilight"><span>Plug your Ethernet cable directly into your router. </span></li>
                <li className="help__hilight"><span>Move closer to the router if you are using wi-fi. </span></li>
              </ol>
              <li className="help__hilight"><span>On a mobile device: &nbsp;</span></li>
              <ol type="a">
                <li className="help__hilight"><span>Run a speed test to make sure </span><span className="help__hilight">your device&#8217;s bandwidth meets the video call requirements.</span></li>
              </ol>
            </ul>
            <li className="help__hilight"><span>If you have active applications running, close them so that nothing else uses your bandwidth while you&rsquo;re playing. </span></li>
          </ol>
          <p><span className="help__hilight">Note: Your computer may be running slow due to high CPU usage. Try turning your video off when it&rsquo;s not needed. </span></p>
          <h3>If you are having audio issues</h3>
          <ol>
            <li className="help__hilight"><span>Check your system preferences: ensure that audio is not muted and the correct input and output device is selected. </span></li>
            <li className="help__hilight"><span>On a mobile device, try using a headset. </span></li>
            <li className="help__hilight"><span>If you are using a headset, try plugging the cable in into another port.</span></li>
            <li className="help__hilight"><span>Refresh the page. </span></li>
            <li className="help__hilight"><span>If none of the above help, restart your browser. </span></li>
          </ol>
          <h3>If you are having video issues</h3>
          <p><span className="help__hilight">First, make sure you have a strong network connection and close any applications that might be interfering with your call. If that doesn&rsquo;t help, please follow these steps:</span></p>
          <ol>
            <li className="help__hilight"><span>Confirm that your camera is on, pointing towards you and nothing is obstructing it.</span></li>
            <li className="help__hilight"><span>If you are using an external camera, make sure it is plugged in before you join a game. </span></li>
            <li className="help__hilight"><span>Make sure you have selected the right camera. </span></li>
          </ol>
        </div>
      </Panel>
    </div>
  );
}

HelpPanel.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default HelpPanel;
